import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { APP_FORMAT } from 'lib/helpers';
import { Field } from 'redux-form';
import rules, { validator } from 'components/form/validation';
import { RadioBox } from 'pages/common/newPage/form/elements/RadioBox';
import FormRowField from 'pages/common/newPage/form/elements/FormRowField';
import Price from 'pages/common/newPage/form/about/price';
import {
  salesHistoryNotEmpty_sel,
  salesHistoryEditable_sel,
  appraisalPriceType_sel,
} from 'pages/common/artworkForm/ArtworkFormModel';
import { connect } from 'react-redux';
import Autocomplete from 'components/form/select';
import { connect as reconnect } from 'cpcs-reconnect';
import { compose } from 'redux';
import { groupedAuctions as auctionList } from 'domain/auction';
import DateField from 'components/form/DateField';
import { today } from 'lib/envGlobals';
import injectSheet from 'lib/sheet';
import sheet from './sheet';

const normalize = (v, p = '') => {
  return /[^0-9,']+/.test(v) ? p : v.replace(/\D/g, '');
};
const format = (v = '') => v ? new Intl.NumberFormat('en-EN').format(v) : v;
const PRICETYPE_OPTIONS = [
  { value: 'PRIVATE', label: 'Private' },
  { value: 'AUCTION', label: 'Auction' },
  { value: 'APPRAISAL', label: 'Appraisal' },
];

class AppraisalField extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    isEditable: PropTypes.bool,
    isNotEmpty: PropTypes.bool,
    priceType: PropTypes.string,
    auctionList: PropTypes.array.isRequired,
    novalidation: PropTypes.bool,
    showEstimatedPrice: PropTypes.bool,
    modifier: PropTypes.string,
    fixDropdownPadding: PropTypes.bool,
  };

  validate = {
    soldDate: (...args) => {
      const { novalidation, isNotEmpty, showEstimatedPrice } = this.props;
      if (showEstimatedPrice) return rules.salesHistoryFutureDate(...args);
      if (novalidation || !isNotEmpty) return undefined;
      return validator(rules.required, rules.date)(...args);
    },
    seller: rules.strMaxLength(255),
    priceSold: rules.priceSold,
    estimatedPriceEnd: (val, data, props, fieldName) => {
      const minFieldName = fieldName.replace('estimatedPriceEnd', 'estimatedPriceStart');
      return rules.greaterThanFormValue(minFieldName)(val, data, props, fieldName);
    },
  };

  render() {
    const {
      priceType, isEditable,
      auctionList, classes, modifier,
      showEstimatedPrice, fixDropdownPadding,
    } = this.props;
    const disabled = !isEditable;
    return (
      <div className={cx(classes.AppraisalField, { showEstimatedPrice })}>
        <div className={cx(classes.formItem, modifier, 'salesHistory appraisal FirstRow soldDateAndIsPrivate')}>
          <Field
            type="text"
            name="userPrice.soldDate"
            component={FormRowField}
            placeholder={APP_FORMAT}
            validate={this.validate.soldDate}
            modifier={cx('salesHistory dateField appraisal', modifier)}
            disabled={disabled}
            Field={DateField}
            rootTag="div"
            maxDate={showEstimatedPrice ? undefined : today()}
          />
          <Field
            component={RadioBox}
            name="userPrice.priceType"
            values={PRICETYPE_OPTIONS}
            modifier={cx('AOForm-isPrivate', modifier)}
            disabled={disabled}
          />
        </div>
        {
          priceType === 'AUCTION' ?
            <Field
              component={FormRowField}
              Field={Autocomplete}
              id="appraisal--auction"
              name="userPrice.auction"
              placeholder="Auction"
              list={auctionList}
              grouped
              disabled={disabled}
              modifier={cx('salesHistorySellerSelector', modifier)}
              rootTag="div"
              fixDropdownPadding={fixDropdownPadding}
            /> :
            <Field
              type="text"
              name="userPrice.seller"
              component={FormRowField}
              placeholder={priceType === 'APPRAISAL' ? 'Name of the appraiser' : 'Name of the seller'}
              validate={this.validate.seller}
              rootTag="div"
              modifier={cx('salesHistorySellerName', modifier)}
            />
        }
        <div className={classes.priceBox}>
          <ul>
            {
              showEstimatedPrice &&
                <li className={cx(classes.formItem, modifier)}>
                  <div className={cx(classes.range)}>
                    <Field
                      type="text"
                      id="userPrice.estimatedPriceStart.value"
                      name="userPrice.estimatedPriceStart.value"
                      component={FormRowField}
                      placeholder="price from"
                      format={format}
                      normalize={normalize}
                      rootTag="div"
                      modifier={cx('priceField salesHistoryEstimatedPrice', modifier)}
                      disabled={disabled}
                    />
                    <Field
                      type="text"
                      id="userPrice.estimatedPriceEnd.value"
                      name="userPrice.estimatedPriceEnd.value"
                      component={FormRowField}
                      placeholder="price to"
                      validate={this.validate.estimatedPriceEnd}
                      format={format}
                      normalize={normalize}
                      rootTag="div"
                      modifier={cx('priceField salesHistoryEstimatedPrice', modifier)}
                      disabled={disabled}
                    />
                  </div>
                </li>
            }
            <Price
              isEditable={isEditable}
              disabled={disabled}
              name="userPrice.priceSold.value"
              currencyName="userPrice.currency"
              modifier={cx(modifier, 'salesHistory-priceSold')}
              validate={this.validate.priceSold}
            />
          </ul>
        </div>
      </div>
    );
  }
}

export default compose(
  injectSheet(sheet),
  reconnect({
    auctionList,
  }),
  connect((state, props) => ({
    priceType: appraisalPriceType_sel(state, props),
    isEditable: salesHistoryEditable_sel(state, props),
    isNotEmpty: salesHistoryNotEmpty_sel(state, props),
  })),
)(AppraisalField);
